<template>
  <div class="zm-classes-list-wrapper" ref="wrapperRef">
    <div id="zm-classes-list" ref="contentRef">
      <HDFHeader03 />
    <main>
      <div class="title-container">
        <div class="title-text">
          <div class="title-text-zm">智码</div>
          <div class="title-text-kczx">课程中心</div>
        </div>
        <div class="title-bg"></div>
      </div>
      <div class="content">
        <!-- TODO 搜索 -->
        <!-- <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="dict in dict.type.video_group_type"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            ></el-option> -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="排序">
            <el-select v-model="formInline.sortValue" placeholder="全部" clearable style="width: 200px">
              <el-option label="全部" value="" />
              <el-option v-for="(item,index) in sortList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="种类">
            <el-select v-model="formInline.typeValue" placeholder="全部" clearable style="width: 200px">
              <el-option label="全部" value="" />
              <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="查找">
            <el-input v-model="formInline.keyword" placeholder="课程" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" :icon="Search" style="margin:0;">搜索</el-button>
          </el-form-item>
        </el-form>
        <ZhimaSeriesCard :list="list1" title="科创开题" :titleData="list1TitleData" />
        <ZhimaSeriesCard :list="list2" title="等考冲刺" :titleData="list2TitleData" />
        <ZhimaSeriesCard :list="list3" title="教师资料" :titleData="list3TitleData" />
      </div>
    </main>
    <HDFFooter03 />
    </div>
  </div>
</template>

<script setup>
import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'
import ZhimaSeriesCard from '@/components/ZhimaSeriesCard.vue'
import { onMounted, onBeforeUnmount, reactive, ref } from 'vue'
import { getVideoBannerList, getVideoGroupList } from '@/api/video'
import { GetDict } from '@/api/api'

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

const formInline = reactive({
  user: '',
  region: '',
  sortValue: '',
  typeValue: '',
  date: '',
  keyword: '',
})

const sortList = ref([])
const typeList = ref([])

const list1 = ref([])
const list2 = ref([])
const list3 = ref([])

const list1TitleData = reactive({
  title: '主推课程1',
  url: '',
})

const list2TitleData = reactive({
  title: '主推课程2',
  url: '',
})

const list3TitleData = reactive({
  title: '主推课程3',
  url: '',
})

const getVideoGroupListx = () => {
  getVideoGroupList({name: formInline.keyword, type: formInline.typeValue, sortType: formInline.sortValue}).then(response => {
    const res = response.data;
    if(res.code === 200){
      console.log(res.data)
      const groupList = res.data;
      list1.value = groupList.list1
      list2.value = groupList.list2
      list3.value = groupList.list3
    }
  })
}

const getVideoCardTitleData = () => {
  getVideoBannerList({}).then(response => {
    const res = response.data;
    if(res.code === 200){
      const data = res.data;
      if(data.list1){
        const {title, url} = data.list1
        list1TitleData.title = title
        list1TitleData.url = url
      }
      if(data.list2){
        const {title, url} = data.list2
        list2TitleData.title = title
        list2TitleData.url = url
      }
      if(data.list3){
        const {title, url} = data.list3
        list3TitleData.title = title
        list3TitleData.url = url
      }
    }
  })
}

const getDicts = () => {
  GetDict().then((res) => {
    const data = res.data.data;
    sortList.value = data.videoSortTypeList
    typeList.value = data.videoGroupTypeList
  })
}

const onSubmit = () => {
  getVideoGroupListx();
}

onMounted(()=>{
  getVideoGroupListx();
  getDicts();
  getVideoCardTitleData();
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})

</script>

<style scoped>
.zm-classes-list-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

#zm-classes-list {
  width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: top left;
}
main {
  background: url('@/assets/images/bg/bg-personalcenter.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.title-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding: 40px 0;
  background-color: rgba(253, 240, 233, 1);
}
.title-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  /* align-items: center; */
  width: 200px;
}
.title-text-zm {
  padding: 20px 20px;
  border-radius: 20px;
  background-color: rgba(0, 50, 100, 1);
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  /* flex: 1; */
}
.title-text-kczx {
  color: rgba(0, 50, 100, 1);
  font-size: 36px;
  letter-spacing: 6px;
}
.title-bg {
  width: 402px;
  height: 251px;
  background: url('@/assets/images/zhima/series-list/bg-book.png');
}
.content {
  background: url('@/assets/images/zhima/series-list/bg-series-list.jpg') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 40px;
}

/* 搜索 */
.demo-form-inline {
  padding: 60px 0 0 0;
  display: flex;
  align-items: center;
}
</style>
